import { render, staticRenderFns } from "./CreatedProductGroup.vue?vue&type=template&id=134a61f2&"
import script from "./CreatedProductGroup.vue?vue&type=script&lang=js&"
export * from "./CreatedProductGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports